<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter_title"><a id="page_18"></a><a id="pg18lev1"></a>PRESERVED KUMQUAT VINAIGRETTE</h2>
<p class="recipe_hdnote">Preserved kumquats, salty and tart-sweet, make a great vinaigrette. I like the combination of kumquats, shallots, and serrano chiles here. Use this dressing for just about any salad.</p>
<p class="yield">MAKES ABOUT <sup>1</sup>/<sub>2</sub> CUP (120 ML)</p>
<p class="ingred_sublistt"><em>4 preserved kumquats with lime and chile <a href="#/xhtml/09chapter02#pg17lev1">(page 17)</a>, finely chopped</em></p>
<p class="ingred_sublist"><em>2 small shallots, finely chopped</em></p>
<p class="ingred_sublist"><em>12 thin slices serrano chile (or adjust to desired spiciness)</em></p>
<p class="ingred_sublist"><em>Juice of 2 lemons</em></p>
<p class="ingred_sublist"><em>Juice of 2 limes</em></p>
<p class="ingred_sublist"><em><sup>1</sup>/<sub>4</sub> cup [60 ml] extra-virgin olive oil</em></p>
<p class="ingred_sublist"><em>Fresh black pepper</em></p>
<p class="method_txt">Mix the kumquats, shallots, and chiles in a small bowl. Whisk in the lemon juice, lime juice, and olive oil. Add several grinds of black pepper and whisk to combine. Serve immediately or store in a covered container in the refrigerator for up to 1 week.</p>
<div class="wrap">
<p class="image"><a id="page_19"></a><img alt="image" class="vertical" src="images/f0019-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10chapter03.vue?59d38180